// extracted by mini-css-extract-plugin
module.exports = {"list":"util-MediaObjectGrid__list--4VL7l"};